export default "__VITE_ASSET__379e4ac5__"